import React from 'react';

import { BaseButton } from '@components/primitives';
import { SimpleCircleSpinner } from '@components/spinners';
import { useFormContext } from '@utils/hooks/useFormContexts';

import type { SubmitButtonProperties } from './SubmitButton.types';

export const SubmitButton: React.FC<SubmitButtonProperties> = ({
  dataTest = 'submit_button',
  isDisabled,
  isLoading = false,
  color,
  onClick,
  label,
  variant = 'contained',
  sx,
  size = 'large',
}) => {
  const form = useFormContext();

  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <form.Subscribe
      selector={state => ({
        isSubmitting: state.isSubmitting,
        isValidating: state.isValidating,
      })}
    >
      {({ isSubmitting, isValidating }) => {
        const isProcessing = isSubmitting || isValidating || isLoading;

        return (
          <BaseButton
            dataTest={dataTest}
            variant={variant}
            type='submit'
            color={color}
            disabled={isProcessing || isDisabled}
            onClick={handleClick}
            size={size}
            startIcon={
              <SimpleCircleSpinner size='20' isLoading={isProcessing} />
            }
            sx={{ width: '100%', ...sx }}
          >
            {label}
          </BaseButton>
        );
      }}
    </form.Subscribe>
  );
};
